/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { RoleType } from './RoleType';
import {
    RoleTypeFromJSON,
    RoleTypeFromJSONTyped,
    RoleTypeToJSON,
} from './RoleType';

/**
 * 
 * @export
 * @interface RoleCatalogDto
 */
export interface RoleCatalogDto {
    /**
     * 
     * @type {number}
     * @memberof RoleCatalogDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RoleCatalogDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof RoleCatalogDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RoleCatalogDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RoleCatalogDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RoleCatalogDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RoleCatalogDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleCatalogDto
     */
    displayName?: string | null;
    /**
     * 
     * @type {RoleType}
     * @memberof RoleCatalogDto
     */
    type?: RoleType;
    /**
     * 
     * @type {string}
     * @memberof RoleCatalogDto
     */
    $type?: RoleCatalogDtoTypeEnum;
}


/**
 * @export
 */
export const RoleCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationRolesDtoRoleCatalogDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Roles.Dto.RoleCatalogDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RoleCatalogDtoTypeEnum = typeof RoleCatalogDtoTypeEnum[keyof typeof RoleCatalogDtoTypeEnum];


/**
 * Check if a given object implements the RoleCatalogDto interface.
 */
export function instanceOfRoleCatalogDto(value?: unknown): value is RoleCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RoleCatalogDtoTypeEnum)[0];
}

export function RoleCatalogDtoFromJSON(json: any): RoleCatalogDto {
    return RoleCatalogDtoFromJSONTyped(json, false);
}

export function RoleCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleCatalogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'type': !exists(json, 'type') ? undefined : RoleTypeFromJSON(json['type']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function RoleCatalogDtoToJSON(value?: RoleCatalogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'name': value.name,
        'iuid': value.iuid,
        'displayName': value.displayName,
        'type': RoleTypeToJSON(value.type),
        '$type': value.$type,
    });
}

